import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { connect } from '@atlassian/jira-react-redux';
import mapDispatchToProps from './command';
import mapStateToProps from './query';
import type { CommandProps, OwnProps, QueryProps } from './types';
import View from './view';
import ViewOld from './view-old';

const Connected = connect<QueryProps, CommandProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps,
)(View);

const ConnectedOld = connect<QueryProps, CommandProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps,
)(ViewOld);

export default componentWithCondition(
	() => fg('plan_timeline_sort_goal_groups_alphabetically'),
	Connected,
	ConnectedOld,
);
